module.exports = __webpack_public_path__ + "static/media/Trebuchet MS-01.4b9cd8e7.svg";